/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Descriptions, Tabs, Card, Col, Row, Button, Tooltip, Alert } from 'antd';
import { CommentOutlined, EditOutlined } from "@ant-design/icons";
import 'leaflet/dist/leaflet.css';

import { camelCaseToTitle } from '../../helpers/StringHelper'
import {
  getOutputLabel,
  getFormInputs,
  getInputContent
} from "./helper";
import { showHideForm, getFormOptions } from "../../helpers/form";
import i18next from 'i18next';
import { getInputHeadLines, getInputLabel, getSectionLabel, propHasValue } from "../DynamicFormNew/helper";
import dot from 'dot-object';
import Styles from "./styles";


export default function DynamicView({
  form: configForm = {},
  data: formDataValues = {},
  tabs,
  excludeKeys,
  options,
  defaultActiveKey = '',
  onTabChange,
  setEditVisible,
  showTitle = true,
  linkedInformation = null,
  isGroupView = false
}) {
  const data = formDataValues ? JSON.parse(JSON.stringify(formDataValues)) : {};
  const form = configForm ? JSON.parse(JSON.stringify(configForm)) : {};
  const excludedKeys = !excludeKeys
    ? ['id', 'position', 'authorId', 'label', 'outputLabel', 'icon', 'showFormIf', 'sectionLabel', 'introText', 'alertConf']
    : ['id', 'position', 'authorId', 'label', 'outputLabel', 'icon', 'sectionLabel', 'introText', 'alertConf', 'showFormIf'].concat(excludeKeys);
  const [forms, setForms] = useState({});
  const [dataOptions, setDataOptions] = useState([]);
  const [selectedKey, setSelectedKey] = useState(defaultActiveKey);
  const [ajaxModalData, setAjaxModalData] = useState({});

  useEffect(() => {
    if (Object.keys(form).length) {
      if (options && Array.isArray(options) && options.length) {
        setDataOptions(options);
      } else {
        getFormOptions(form, excludedKeys, data)
          .then(options => setDataOptions(options));
      }
      const formsConfig = {};
      Object.keys(form).filter(key => !excludedKeys.includes(key)).forEach(f => {
        const formId = form[f].dataId || f;
        formsConfig[f] = {
          label: (form[f].label || form[f].outputLabel) ? (form[f].outputLabel || getOutputLabel(form[f], data)) : camelCaseToTitle(f),
          formDescription: form[f].formDescription,
          name: formId,
          show: form[f].showFormIf ? showHideForm(form[f], data) : true,
          alertConf: form[f].alertConf ? form[f].alertConf : undefined,
          inputs: getFormInputs(Object.keys(form[f]).filter(key =>
            !excludedKeys.includes(key) && form[f][key] && (form[f][key].inputType || form[f][key].inputs)), form[f], data, excludedKeys)
        }
      })
      setForms({
        ...formsConfig,
      });
    }

  }, [configForm, formDataValues]);

  const showedForms = Object.keys(forms).filter(f => forms[f].show);
  useEffect(() => {
    if (!selectedKey || selectedKey === '') {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      defaultActiveKey = selectedKey || (showedForms.length ? showedForms[0] : '');
      setSelectedKey(defaultActiveKey);
    }
  }, [defaultActiveKey, tabs, showedForms])


  function getCols(length) {
    return { xl: 24, xxl: 24 };
  }
  const getRepeatableLabel = (field, currentForm) => {
    if (field.headConfig) {
      const [headConfig, prop] = field.headConfig.split('.');
      const input = dot.pick(headConfig, field);
      if (input && propHasValue(input.value)) {
        if (prop && ['modal'].includes(input.inputType)) {
          if (ajaxModalData[input.value] && ajaxModalData[input.value][prop]) {
            return ajaxModalData[input.value][prop];
          }
        } else {
          return getInputContent(input, currentForm, undefined, dataOptions, false, data, {
            ajaxModalData,
            setAjaxModalData
          })
        }
      }
    }
    return field.label;
  }
  function getRepeatableDisplay(f, field, currentForm, space, isGroup = false) {
    const cols = getCols(1);
    const titleForm = field.sectionLabel ? getSectionLabel(field.sectionLabel, data) : getOutputLabel(field, data);
    // const titleForm = getOutputLabel(field, data);
    return <React.Fragment key={`${f}-${field.name}`}>
      <div className={`${isGroup ? '' : 'mb-2'}`} >
        {!isGroup && titleForm && titleForm !== ' ' ? <h4 className="title-semibold-4 mb-0" >{titleForm}</h4> : null}
        {field.inputs.map((iField, fieldInd) => {
          const rInputs = iField.inputs.filter(inputField => !excludedKeys.includes(inputField.name) && inputField.isShown)
            .sort((a, b) => a.position - b.position);
          const rLabel = field.inputs.length === 1 &&
            rInputs.filter(inputField => propHasValue(inputField.value)).length === 0 ?
            i18next.t('No Data') :
            getRepeatableLabel(iField, currentForm, fieldInd);
          return <Row key={`${f}-${iField.name}-${fieldInd}`} gutter={[16, 16]}>
            <Col xs={24} sm={24} md={24} lg={24} xl={cols.xl} xxl={cols.xxl}>
              <Card
                className="multiple-card-view"
                size={"small"}
                title={rLabel}>
                {rInputs.map((inputField, iii) => {
                  const l = getOutputLabel(inputField, data);
                  const noLabel = l === ' ' || (Array.isArray(l) && l.length === 1 && l[0] === ' ');
                  return !noLabel ?
                    <Descriptions bordered layout="horizontal" column={1} size="small">
                      <Descriptions.Item
                        style={{
                          display: inputField &&
                            inputField.inputType === 'ajaxSelect' &&
                            inputField.value === 'new' ? 'none' : 'table-cell'
                        }}
                        label={<span>{l} {
                          (!propHasValue(inputField.value) && inputField.rules && inputField.rules.filter(r => r.required).length > 0) ? <span className="missing">*</span> : ''}</span>}
                        layout={"horizontal"}
                        key={`${f}-${field.name}-${fieldInd}-${iii}`}
                        className={['h1', 'h2', 'h3', 'h4', 'h5'].includes(inputField.inputType) ? 'as-title' : ''}>
                        <div className="d-flex-space">
                          <span style={{ width: '100%' }}>
                            {getInputContent(inputField, currentForm, fieldInd, dataOptions, false, data, {
                              ajaxModalData,
                              setAjaxModalData
                            }) || space}
                          </span>
                          <span>
                            {field && field.inputs && inputField && inputField.commentValue ?
                              <Tooltip title={inputField.commentValue} trigger="click" placement="top">
                                <CommentOutlined className="ml-1" />
                              </Tooltip>
                              : null}
                          </span>
                        </div>
                      </Descriptions.Item>
                    </Descriptions> : (
                      <div className={noLabel ? 'no-label d-flex-space' : 'd-flex-space'} key={`${f}-${field.name}-${fieldInd}-0-${iii}`}>
                        <span style={{ width: '100%' }}>
                          {getInputContent(inputField, currentForm, fieldInd, dataOptions, noLabel, data, {
                            ajaxModalData,
                            setAjaxModalData
                          }) || space}
                        </span>
                        <span>
                          {field && field.inputs && inputField && inputField.commentValue ?
                            <Tooltip title={inputField.commentValue} trigger="click" placement="top">
                              <CommentOutlined className="ml-1" />
                            </Tooltip>
                            : null}
                        </span>
                      </div>
                    )
                }
                )}

              </Card>
            </Col>
          </Row>
        })}
      </div>
    </React.Fragment>
  }
  function getNonRepeatableDisplay(f, field, currentForm, space, isGroup = false) {
    const nonRepeatableTitle = field.sectionLabel ? getSectionLabel(field.sectionLabel, data) : getOutputLabel(field, data);
    // const nonRepeatableTitle = getOutputLabel(field, data);
    const gInputs = field.inputs.filter(inputField => !excludedKeys.includes(inputField.name) && inputField.isShown)
      .sort((a, b) => a.position - b.position);
    return <React.Fragment key={`${f}-${field.name}`}>
      <div className={`${isGroup || gInputs.length < 2 ? '' : 'mb-2'}`} style={isGroup ? {} : {}}>
        {!isGroup && nonRepeatableTitle && nonRepeatableTitle !== ' ' ? <h4 className="title-semibold-4 mb-0">{nonRepeatableTitle}</h4> : null}
        <Descriptions bordered layout="horizontal" className={isGroup || field.sectionLabel || field.label ? "p-0" : "pt-3 pl-0 pr-0"} column={1} size="small">
          {gInputs.map((inputField, iii) =>
            inputField.label !== '' ? <Descriptions.Item
              style={{ display: inputField && inputField.inputType === 'ajaxSelect' && inputField.value === 'new' ? 'none' : 'table-cell' }}
              label={<span>{inputField.sectionLabel ? getSectionLabel(inputField.sectionLabel, data) : getOutputLabel(inputField, data)} {
                (!propHasValue(inputField.value) && inputField.rules && inputField.rules.filter(r => r.required).length > 0) ? <span className="missing">*</span> : ''}</span>}
              layout={"horizontal"}
              key={`${f}-${field.name}-${iii}`}
              className={['h1', 'h2', 'h3', 'h4', 'h5'].includes(inputField.inputType) ? 'as-title' : ''}
            >
              <div className="d-flex-space">
                <span style={{ width: '100%' }}>
                  {getInputContent(inputField, currentForm, undefined, dataOptions, false, data, {
                    ajaxModalData,
                    setAjaxModalData
                  }) || space}
                </span>
                <span>
                  {field && field.inputs && inputField && inputField.commentValue ?
                    <Tooltip title={inputField.commentValue} trigger="click" placement="top">
                      <CommentOutlined className="ml-1" />
                    </Tooltip>
                    : null}
                </span>
              </div>
            </Descriptions.Item> : (
              <div className="d-flex-space" key={`${f}-${field.name}-${iii}`}>
                <span style={{ width: '100%' }}>
                  {getInputContent(inputField, currentForm, undefined, dataOptions, false, data, {
                    ajaxModalData,
                    setAjaxModalData
                  }) || space}
                </span>
                <span>
                  {field && field.inputs && inputField && inputField.commentValue ?
                    <Tooltip title={inputField.commentValue} trigger="click" placement="top">
                      <CommentOutlined className="ml-1" />
                    </Tooltip>
                    : null}
                </span>
              </div>
            )
          )}
        </Descriptions>

      </div>
    </React.Fragment>

  }
  function getGroupDisplay(f, i, field, currentForm, space) {
    try {
      if (field.inputs) {
        const gInputs = Object.keys(field.inputs)
          .filter(inputField =>
            !excludedKeys.includes(inputField) &&
            field.inputs[inputField].isShown
          ).sort((a, b) => field.inputs[a].position - field.inputs[b].position);
        return (
          <div className="mb-2" key={`${f}-${i}`} style={{}}>
            <Row gutter={[16, 16]} className="m-0">
              <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24} className="p-0">
                {getInputHeadLines(field.inputType, i, field, data)}
                {
                  gInputs.map((inputField, iii) => {
                    const inputConfig = field.inputs[inputField];
                    const l = inputConfig.sectionLabel ? getSectionLabel(inputConfig.sectionLabel, data) : getOutputLabel(inputConfig, data);
                    const noLabel = l === ' ' || (Array.isArray(l) && l.length === 1 && l[0] === ' ');
                    return inputConfig.repeatable ? getRepeatableDisplay(f, inputConfig, currentForm, space, true) : (
                      inputConfig.inputs ? getNonRepeatableDisplay(f, inputConfig, currentForm, space, true) :
                        <Descriptions bordered layout="horizontal" key={inputConfig.name} column={1} className="p-0" size="small">
                          {!noLabel ?
                            <Descriptions.Item
                              style={{ display: inputConfig && inputConfig.inputType === 'ajaxSelect' && inputConfig.value === 'new' ? 'none' : 'table-cell' }}
                              label={<span>{l} {
                                (!propHasValue(inputConfig.value) &&
                                  inputConfig.rules &&
                                  inputConfig.rules.filter(r => r.required).length > 0) ? <span className="missing">*</span> : ''}</span>
                              }
                              layout={"horizontal"}
                              key={`${f}-${field.name}-${i}-${iii}`}>
                              <div className="d-flex-space">
                                <span style={{ width: '100%' }}>
                                  {getInputContent(inputConfig, currentForm, undefined, dataOptions, false, data, {
                                    ajaxModalData,
                                    setAjaxModalData
                                  }) || space}
                                </span>
                                <span>
                                  {field && field.inputs && inputConfig && inputConfig.commentValue ?
                                    <Tooltip title={inputConfig.commentValue} trigger="click" placement="top">
                                      <CommentOutlined className="ml-1" />
                                    </Tooltip>
                                    : null}
                                </span>
                              </div>
                            </Descriptions.Item> : (
                              <div className="d-flex-space" key={`${f}-${field.name}-${i}-${iii}`}>
                                <span style={{ width: '100%' }}>
                                  {getInputContent(inputConfig, currentForm, undefined, dataOptions, false, data, {
                                    ajaxModalData,
                                    setAjaxModalData
                                  }) || space}
                                </span>
                                <span>
                                  {field && field.inputs && field.inputs[inputField] && field.inputs[inputField].commentValue ?
                                    <Tooltip title={field.inputs[inputField].commentValue} trigger="click" placement="top">
                                      <CommentOutlined className="ml-1" />
                                    </Tooltip>
                                    : null}
                                </span>
                              </div>
                            )}
                        </Descriptions>
                    )

                  })}
              </Col>
            </Row>
          </div>
        )
      } else {
        return null;
      }
    } catch (e) {
      console.log(e);
      return null
    }
  }
  function getSingleDisplay(f, field, currentForm, space, inRowDescription, isGroup) {
    const l = getInputLabel(field, data);
    return <div key={`${f}-${field.name}`} style={isGroup ? {} : {}}>
      <Descriptions bordered layout="horizontal" className={`pl-0 pr-0 pt-0 ${inRowDescription > 1 ? 'no-top-border' : ''}`} column={1} size="small">
        {l !== ' ' ? <Descriptions.Item
          style={{ display: field && field.inputType === 'ajaxSelect' && field.value === 'new' ? 'none' : 'table-cell' }}
          label={<span>{l} {
            (!propHasValue(field.value) && field.rules && field.rules.filter(r => r.required).length > 0) ? <span className="missing">*</span> : ''}</span>}
          layout={"horizontal"}
          key={`${f}-${field.name}`}
        >
          <div className="d-flex-space">
            <span style={{ width: '100%' }}>
              {getInputContent(field, currentForm, undefined, dataOptions, false, data, {
                ajaxModalData,
                setAjaxModalData
              }) || space}
            </span>
            <span>
              {field && field.inputs && field && field.commentValue ?
                <Tooltip title={field.commentValue} trigger="click" placement="top">
                  <CommentOutlined className="ml-1" />
                </Tooltip>
                : null}
            </span>
          </div>
        </Descriptions.Item> : (
          <div className="d-flex-space" key={`${f}-${field.name}`}>
            <span style={{ width: '100%' }}>
              {getInputContent(field, currentForm, undefined, dataOptions, false, data, {
                ajaxModalData,
                setAjaxModalData
              }) || space}
            </span>
            <span>
              {field && field.inputs && field && field.commentValue ?
                <Tooltip title={field.commentValue} trigger="click" placement="top">
                  <CommentOutlined className="ml-1" />
                </Tooltip>
                : null}
            </span>
          </div>
        )}
      </Descriptions>
    </div>
  }
  function dynamicFormView(f, ind) {
    const { label, formDescription, name, alertConf, inputs, show = true } = forms[f];
    const space = <span>&nbsp;</span>;
    const currentForm = inputs.filter(field => !excludedKeys.includes(field.name) && (field.isShown ||
      (
        field.inputs &&
        field.inputs.filter(i => i.isShown).length
      ))).sort((a, b) => a.position - b.position);
    let inRowDescription = 0;
    // try {
    return show ? <React.Fragment key={`${f}-${ind}`}>
      {showTitle ?
        <h3 className="title-semibold-3 group-header mb-0" style={{ margin: `16px 16px ${tabs ? '10px 0px' : '0px 16px'}` }}>
          <span className="bg-white">{formDescription ? formDescription : (label ? label : camelCaseToTitle(name))}
            {!tabs && setEditVisible ? (
              <Button
                type="link"
                key={`${name}-edit-button`}
                icon={<EditOutlined />}
                onClick={() => setEditVisible(f)}>
              </Button>
            ) : null}
          </span>
        </h3>
        : null
      }
      {alertConf && typeof alertConf === "object" ? <Alert
        message={alertConf.text}
        type={alertConf.type}
        closable={alertConf.closable} /> : null}
      <div className={`${isGroupView ? " " : 'pb-3 '}`} style={{ display: 'flex', flexDirection: 'column' }}>
        {currentForm.map((field, i) => {
          if (field.display === 'group') {
            inRowDescription = 0;
            return getGroupDisplay(f, i, field, currentForm, space);
          } else if (field.inputs) {
            inRowDescription = 0;
            if (field.repeatable) {
              return getRepeatableDisplay(f, field, currentForm, space, isGroupView);
            } else {
              return getNonRepeatableDisplay(f, field, currentForm, space)
            }
          } else {
            inRowDescription += 1;
            return getSingleDisplay(f, field, currentForm, space, inRowDescription, isGroupView);
          }
        })}
      </div>

    </React.Fragment> : null;

    // } catch (e) {
    //   console.log(e);
    //   return <React.Fragment>
    //     {currentForm.label ? <h4 className="title-semibold-4" style={{ margin: `16px 16px ${tabs ? '10px 0px' : '0px 16px'}` }}>
    //       {currentForm.label ? currentForm.label : camelCaseToTitle(f)}
    //     </h4> : null}
    //   </React.Fragment>
    // }
  }

  return Object.keys(forms).length > 0 ?
    <Styles style={{ flexDirection: tabs ? 'row' : 'column', height: 'calc(100% - 50px)' }}>
      {tabs ?
        <Tabs
          onChange={(activeKey) => {
            if (onTabChange) {
              onTabChange(activeKey);
            }
            setSelectedKey(activeKey);
          }}
          defaultActiveKey={selectedKey}
          activeKey={selectedKey}
          tabPosition="left"
          items={[
            ...(showedForms.map((f) => ({
              label: `${forms[f].label}`,
              key: f,
              tabKey: `${forms[f].label}`,
              children: dynamicFormView(f),
            }))),
            ...(linkedInformation ? [{
              label: i18next.t('Linked Information'),
              key: 'linkedInformation',
            }] : []),
          ]}
        /> : <React.Fragment>
          {(showedForms
            .map((f, fi) => dynamicFormView(f, fi)))}
          {linkedInformation ? <div style={{ display: 'column', flexDirection: 'column', padding: '20px' }}>
            <h3 className="title-semibold-3 group-header">{i18next.t('Linked Information')}</h3>
            <span className="bg-white">{linkedInformation}</span>
          </div> : null
          }
        </React.Fragment>
      }
    </Styles >
    : null
}
